import React, { useCallback } from 'react';
import { InputNumber } from 'antd';
import styled from 'styled-components';

interface NumberFieldProps {
  id?: string;
  value?: number;
  placeholder?: string;
  min?: number;
  max?: number;
  maxLength?: number;
  error?: boolean;
  disabled?: boolean;
  onChange?: (value: number | null) => void;
  onBlur?: () => void;
}
const NumberField: React.FC<NumberFieldProps> = ({
  id,
  value,
  placeholder,
  min,
  max,
  maxLength,
  error,
  disabled,
  onChange,
  onBlur,
}) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      const allowedKeys = [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Tab',
        'Home',
        'End',
      ];
      if (!allowedKeys.includes(e.key) && (e.key < '0' || e.key > '9')) {
        e.preventDefault();
      }
    },
    [],
  );
  const handlePaste = useCallback(
    (e: React.ClipboardEvent<HTMLInputElement>) => {
      const text = e.clipboardData.getData('text');
      if (!/^\d+$/.test(text)) {
        e.preventDefault();
      }
    },
    [],
  );
  const handleChange = useCallback(
    (val: string | number | null) => {
      if (val === null) {
        onChange?.(null);
        return;
      }
      let newVal = Number(val);
      if (Number.isNaN(newVal)) return;
      if (maxLength) {
        newVal = Number(String(newVal).slice(0, maxLength));
      }
      onChange?.(newVal);
    },
    [maxLength, onChange],
  );
  return (
    <StyledInputNumberAntd
      id={id}
      value={value}
      placeholder={placeholder}
      min={min}
      max={max}
      maxLength={maxLength}
      disabled={disabled}
      error={error}
      inputMode="numeric"
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      onChange={handleChange}
      onBlur={onBlur}
    />
  );
};
export default NumberField;
const StyledInputNumberAntd = styled(InputNumber)<{ error?: boolean }>`
  height: 44px;
  border: 1px solid ${({ error }) => (error ? 'var(--color-10)' : '#dcdcdc')};
  border-radius: 6px;
  font-size: 14px;
  width: 100%;
  overflow: hidden;
  &:hover {
    border-color: ${({ error }) =>
      error ? 'var(--color-10)' : 'var(--color-14)'};
  }
  &.ant-input-number-focused {
    border-color: ${({ error }) =>
      error ? 'var(--color-10)' : 'var(--color-14)'};
    box-shadow: none;
  }
  .ant-input-number-input-wrap {
    height: 100%;
  }
  .ant-input-number-input {
    height: 100%;
    padding: 0px 12px;
  }
  .ant-input-number-handler-wrap {
    opacity: 1;
  }
`;
